import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from 'context/auth';

interface ProtectedRouteProps {
  children: ReactNode;
}

function ProtectedRoute({ children }: ProtectedRouteProps): JSX.Element {
  const { user, loading } = useAuth();

  // Show nothing while checking authentication status
  if (loading) {
    return <></>;
  }

  // If not authenticated, redirect to auth-required page
  if (!user) {
    return <Navigate to="/auth-required" />;
  }

  // If authenticated, render the protected route
  return <>{children}</>;
}

export default ProtectedRoute;
